import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

import {
  getLabelNivelCaixaria,
  formatPeso,
  disablePeso,
  getEstoqueLabel,
} from '../../utils';

function getDados12(dados) {
  const unidades = dados.unidades_caixa_aparente
    ? dados.unidades_caixa_aparente
    : dados.unidades_caixa
    ? dados.unidades / dados.unidades_caixa
    : dados.unidades;

  const sufixoUnidade = dados.unidades_caixa_aparente
    ? dados.peso_caixa > 0
      ? `${getLabelNivelCaixaria(dados.nivel_caixaria)}(${formatPeso(
          dados.peso_caixa,
        )})`
      : `${getLabelNivelCaixaria(dados.nivel_caixaria)}(${
          dados.unidades_caixa
        } un)`
    : dados.unidades_caixa
    ? `cx(${dados.unidades_caixa} un)`
    : '';

  return unidades
    ? `${unidades} ${sufixoUnidade}`
    : disablePeso(dados.produto)
    ? formatPeso(dados.peso)
    : '-';
}

function getDados(dados) {
  const produto = dados.produto;
  const unidades = dados.unidades;
  const peso = dados.peso;

  return getEstoqueLabel(produto, unidades, peso);
}

const QuantidadeField = ({ ...props }) => {
  const record = useRecordContext(props);

  const label = record ? (record.record ? getDados(record.record) : '-') : '-';

  return (
    <div>
      <Typography variant="subtitle1">{label}</Typography>
    </div>
  );
};

export default QuantidadeField;
